const SPLIT_REGEX = /\s+/u;
const abbreviate = (str, letterCount = 2) => {
  const words = str?.trim().split(SPLIT_REGEX).map((w) => w.trim());
  if (!words)
    return null;
  if (letterCount === 1)
    return words[0].charAt(0).toLocaleUpperCase("ru-RU");
  if (words.length === 1)
    return words[0].substring(0, 2).toLocaleUpperCase("ru-RU");
  return words[0].charAt(0).toUpperCase() + words[1].charAt(0).toLocaleUpperCase("ru-RU");
};
const getRadialGradient = (gradient) => {
  const { top, left, position, color } = gradient;
  const positions = Object.entries(position).map(([key, value]) => `${color[key]} ${value}%`).join(", ");
  return `radial-gradient(circle at ${left}% ${top}%, ${positions})`;
};
export {
  abbreviate,
  getRadialGradient
};
